import { CircularProgress, makeStyles } from "@material-ui/core";
import { PaymentContext } from "contexts/PaymentContext";
import React, { useContext, useState } from "react";
import "./index.css";
import { ChevronUp, ShoppingCart, X } from "lucide-react";
import { Alert, AlertTitle } from "@material-ui/lab";
import Price from "components/Price";
import Resume from "../Resume";

const useStyles = makeStyles((theme) => ({
  listItem: {
    padding: 0,
    flexWrap: "wrap",
  },
  listItemTitle: {
    width: "100%",
  },
  simpleList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    color: "#676f7e",
    fontSize: "14px",
  },
  label: {
    color: "#676f7e",
    marginBottom: "8px",
    fontSize: "14px",
  },
  simpleListItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    marginBottom: "12px",
  },
  flexColumn: {
    flexDirection: "column",
    marginBottom: "16px",
  },
  simpleListItemHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#676f7e",
  },
  strong: {
    color: "#21242c",
  },
  svg: {
    width: "12px",
    height: "12px",
    marginTop: "4px",
  },
  svgBig: {
    width: "16px",
    height: "16px",
  },
}));

const MobileSidebar = (props) => {
  const [paymentContext] = useContext(PaymentContext);
  const hasExtraPaymentServices = paymentContext.hasExtraPaymentServices;

  const {
    enableTagManager = false,
    nationTitle = "Paese",
    groupTitle = "Pacchetto",
    packageTitle,
    departureTitle = "Partenza",
    /*structureTitle = 'Struttura',*/
    structureTitle = "Selezione",
    programTypologyTitle = "Tipologia di programma",
    selectedGroup,
    selectedTurn,
    // alternativeGroup,
    // alternativeTurn,
    bonusValue,
    // contributoValue,
    appState,
    packageSelectorState,
    // alternativePsState,
    // priceToPay = 0,
    totalPrice = 0,
    visualTotalPrice = null,
    depositPrice = 0,
    hasPaymentError = false,
    isLoadingPrice,

    onNext,
    sendBookingButtonLabel,
    isSubmitting,
    stepsByName,
  } = props;

  const { activeStep } = appState;

  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);

  const showButton = activeStep !== stepsByName.RECAP;

  return (
    <div className="mobile-summary">
      <button
        className="summary-trigger"
        onClick={() => {
          setIsOpen(true);
          document.body.style.overflow = "hidden";
        }}
      >
        <div className="summary-trigger-left">
          <ShoppingCart className="icon-sm icon-primary" />
          <div className="text-left">
            <p className="text-xs-muted">Totale ordine</p>
            <p className="text-2xl-black">
              {isLoadingPrice ? (
                <CircularProgress className="progress-size" size={16} />
              ) : (
                <span className={classes.price}>
                  €{totalPrice < 0 ? 0 : totalPrice / 100}
                </span>
              )}
            </p>
          </div>
        </div>

        <div className="summary-trigger-right">
          <span className="text-sm-primary">Vedi dettagli</span>
          <ChevronUp
            className={`icon-sm icon-primary ${isOpen ? "rotate" : ""}`}
          />
        </div>
      </button>

      <div className={`summary-sheet ${isOpen ? "is-open" : ""}`}>
        <header className="sheet-header">
          <h2 className="sheet-title">
            <ShoppingCart className="icon-md" />
            Riepilogo Ordine
          </h2>
          <button
            className="close-summary"
            onClick={() => {
              setIsOpen(false);
              document.body.style.overflow = "initial";
            }}
          >
            <X />
          </button>
        </header>
        <br />
        {hasPaymentError && (
          <Alert severity="error">
            <AlertTitle>Attenzione, si è verificato un problema.</AlertTitle>
            Contatta il nostro staff per ricevere assistenza, dal Lun al Ven:
            8:30 - 17:30, ai numeri di telefono 0736 343440 - 0736 336339 Oppure
            riprova più tardi.
          </Alert>
        )}

        <Price depositPrice={hasExtraPaymentServices ? depositPrice : 0}>
          <Resume
            isMobile
            hasPaymentError={hasPaymentError}
            appState={appState}
            packageSelectorState={packageSelectorState}
            nationTitle={nationTitle}
            selectedGroup={selectedGroup}
            groupTitle={groupTitle}
            selectedTurn={selectedTurn}
            packageTitle={packageTitle}
            departureTitle={departureTitle}
            structureTitle={structureTitle}
            programTypologyTitle={programTypologyTitle}
            enableTagManager={enableTagManager}
            summaryStepIndex={stepsByName.RECAP}
            totalPrice={totalPrice}
            bonusValue={bonusValue}
            visualTotalPrice={visualTotalPrice}
          />
        </Price>
        {showButton && (
          <button className="confirm-button" onClick={onNext}>
            {isSubmitting ? (
              <CircularProgress size={16} />
            ) : (
              <>
                {activeStep === stepsByName.RECAP - 1
                  ? sendBookingButtonLabel
                  : "Avanti"}
              </>
            )}
          </button>
        )}
      </div>

      {isOpen && (
        <div
          className="sheet-backdrop"
          onClick={() => {
            setIsOpen(false);
            document.body.style.overflow = "auto";
          }}
        />
      )}
    </div>
  );
};

export default MobileSidebar;
